import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from './helpers/custom-route-reuse-strategy';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { RoutingModule } from './modules/routing/routing.module';
import { SharedModule } from './modules/shared/shared.module';

import { HttpModule, Http, BaseRequestOptions } from '@angular/http';
import { AuthHttp, AUTH_PROVIDERS, provideAuth, AuthConfig } from 'angular2-jwt/angular2-jwt';
export function getAuthHttp(http) {
  return new AuthHttp(new AuthConfig({
    tokenName: 'token'
  }), http);
}
import { HttpClientModule, HttpClient } from '@angular/common/http';

import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import localeItExtra from '@angular/common/locales/extra/it';

registerLocaleData(localeIt, localeItExtra);

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatPaginatorIntl,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,

  MAT_PLACEHOLDER_GLOBAL_OPTIONS
} from '@angular/material';

import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';

import { DragulaModule } from 'ng2-dragula/ng2-dragula';

import { ClipboardModule } from 'ngx-clipboard';

import { Angular2SocialLoginModule } from "angular2-social-login";

import { ToastyModule } from 'ng2-toasty';

import { StickyModule } from 'ng2-sticky-kit';

import { TinymceModule } from 'angular2-tinymce';

import { CurrencyMaskModule } from "ng2-currency-mask";

import { FileUploadModule } from 'ng2-file-upload';

import { AppSnackbarComponent } from './helpers/app-snackbar.component';
import { MatPaginatorIntlIt } from './helpers/mat-paginator-intl-IT';

import { AppComponent } from './app.component';
import { EmployeeSearchComponent } from './components/employee-search/employee-search.component';
import { EmployeeFormComponent } from './components/employee-form/employee-form.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { AdminComponent } from './components/admin/admin.component';
import { NoAccessComponent } from './components/no-access/no-access.component';
import { LogoComponent } from './components/logo/logo.component';
import { CollanaSearchComponent } from './components/collana/collana-search/collana-search.component';
import { CollanaFormComponent } from './components/collana/collana-form/collana-form.component';
import { CollanaPreviewComponent } from './components/collana/collana-preview/collana-preview.component';
import { BookSearchComponent } from './components/book/book-search/book-search.component';
import { BookFormComponent } from './components/book/book-form/book-form.component';
import { CollanaSelectorComponent } from './components/collana/collana-selector/collana-selector.component';
import { ContributorSearchComponent } from './components/contributor/contributor-search/contributor-search.component';
import { LetterAvatarComponent } from './helpers/letter-avatar.component';
import { CatalogazioneSelectorComponent } from './components/book/catalogazione-selector/catalogazione-selector.component';
import { DeweySelectorComponent } from './components/book/dewey-selector/dewey-selector.component';
import { FormValidationSampleComponent } from './test/form-validation-sample/form-validation-sample.component';
import { ShowErrorsComponent } from './helpers/show-errors/show-errors.component';
import { BirthYearValidatorDirective } from './helpers/validators/birth-year-validator.directive';
import { FormValidationCustomComponent } from './test/form-validation-custom/form-validation-custom.component';
import { CatalogazioneValidatorDirective } from './helpers/validators/catalogazione-validator.directive';
import { ContributorSelectorComponent } from './components/book/contributor-selector/contributor-selector.component';
import { ContributorValidatorDirective } from './helpers/validators/contributor-validator.directive';
import { Ean13ValidatorDirective } from './helpers/validators/ean13-validator.directive';
import { DeweyValidatorDirective } from './helpers/validators/dewey-validator.directive';
import { EditoreSelectorComponent } from './components/editore/editore-selector/editore-selector.component';
import { OnixSelectorComponent } from './components/onix/onix-selector/onix-selector.component';
import { RelatedProductSelectorComponent } from './components/book/related-product-selector/related-product-selector.component';
import { RelatedProductValidatorDirective } from './helpers/validators/related-product-validator.directive';
import { LinguaSelectorComponent } from './components/book/lingua-selector/lingua-selector.component';
import { LinguaValidatorDirective } from './helpers/validators/lingua-validator.directive';
import { CollanaComboSelectorComponent } from './components/collana/collana-combo-selector/collana-combo-selector.component';
import { ArgomentoSearchComponent } from './components/argomento/argomento-search/argomento-search.component';
import { ArgomentoSelectorComponent } from './components/book/argomento-selector/argomento-selector.component';
import { ArgomentoValidatorDirective } from './helpers/validators/argomento-validator.directive';
import { DestinatarioValidatorDirective } from './helpers/validators/destinatario-validator.directive';
import { DistributoreSelectorComponent } from './components/book/distributore-selector/distributore-selector.component';
import { ServizioStampaComponent } from './components/book/servizio-stampa/servizio-stampa.component';
import { Ean13FilterComponent } from './helpers/filters/ean13-filter/ean13-filter.component';
import { CollanaFilterComponent } from './helpers/filters/collana-filter/collana-filter.component';
import { BookRowCatalogoDirective } from './components/book/book-row-catalogo.directive';
import { TitoloFilterComponent } from './helpers/filters/titolo-filter/titolo-filter.component';
import { StagionalitaValidatorDirective } from './helpers/validators/stagionalita-validator.directive';
import { ContributorFilterComponent } from './helpers/filters/contributor-filter/contributor-filter.component';
import { AnnoFilterComponent } from './helpers/filters/anno-filter/anno-filter.component';
import { BisacSearchComponent } from './components/bisac/bisac-search/bisac-search.component';
import { BisacSelectorComponent } from './components/book/bisac-selector/bisac-selector.component';
import { CoversUploaderComponent } from './helpers/covers-uploader/covers-uploader.component';
import { ContributorAddComponent } from './components/contributor/contributor-add/contributor-add.component';
import { ContributorFormComponent } from './components/contributor/contributor-form/contributor-form.component';
import { ContributorSearchListComponent } from './components/contributor/contributor-search-list/contributor-search-list.component';
import { CceSearchComponent } from './components/cce/cce-search/cce-search.component';
import { CceSelectorComponent } from './components/book/cce-selector/cce-selector.component';
import { UppercaseDirective } from './helpers/uppercase.directive';
import { MatIconDehonianeComponent } from './helpers/mat-icon-dehoniane/mat-icon-dehoniane.component';
import { RecensioneFormComponent } from './components/recensione/recensione-form/recensione-form.component';
import { TestataComboSelectorComponent } from './components/recensione/testata-combo-selector/testata-combo-selector.component';
import { CopertinarioComponent } from './helpers/copertinario/copertinario.component';
import { ExtraFormComponent } from './components/extra/extra-form/extra-form.component';
import { TestataSearchComponent } from './components/testata/testata-search/testata-search.component';
import { TestataFormComponent } from './components/testata/testata-form/testata-form.component';
import { ArticoloSearchComponent } from './components/articolo/articolo-search/articolo-search.component';
import { ArticoloFormComponent } from './components/articolo/articolo-form/articolo-form.component';
import { NumeroFilterComponent } from './helpers/filters/numero-filter/numero-filter.component';
import { TipoArticoloSelectorComponent } from './components/articolo/tipo-articolo-selector/tipo-articolo-selector.component';
import { AlfrescoArticoloSelectorComponent } from './components/articolo/alfresco-articolo-selector/alfresco-articolo-selector.component';
import { CatalogazioneArticoloSelectorComponent } from './components/articolo/catalogazione-articolo-selector/catalogazione-articolo-selector.component';
import { IndiceGeoSelectorComponent } from './components/articolo/indice-geo-selector/indice-geo-selector.component';
import { MatIconMariettiComponent } from './helpers/mat-icon-marietti/mat-icon-marietti.component';
import { TestataAutocompleteComponent } from './components/recensione/testata-autocomplete/testata-autocomplete.component';

@NgModule({
  declarations: [
    AppSnackbarComponent,

    AppComponent,
    EmployeeSearchComponent,
    EmployeeFormComponent,
    HomeComponent,
    LoginComponent,
    AdminComponent,
    NoAccessComponent,
    LogoComponent,
    CollanaSearchComponent,
    CollanaFormComponent,
    CollanaPreviewComponent,
    BookSearchComponent,
    BookFormComponent,
    CollanaSelectorComponent,
    ContributorSearchComponent,

    LetterAvatarComponent,

    CatalogazioneSelectorComponent,

    DeweySelectorComponent,

    FormValidationSampleComponent,

    ShowErrorsComponent,

    BirthYearValidatorDirective,

    FormValidationCustomComponent,

    CatalogazioneValidatorDirective,

    ContributorSelectorComponent,

    ContributorValidatorDirective,

    Ean13ValidatorDirective,

    DeweyValidatorDirective,

    EditoreSelectorComponent,

    OnixSelectorComponent,

    RelatedProductSelectorComponent,

    RelatedProductValidatorDirective,

    LinguaSelectorComponent,

    LinguaValidatorDirective,

    CollanaComboSelectorComponent,

    ArgomentoSearchComponent,

    ArgomentoSelectorComponent,

    ArgomentoValidatorDirective,

    DestinatarioValidatorDirective,

    DistributoreSelectorComponent,

    ServizioStampaComponent,

    Ean13FilterComponent,

    CollanaFilterComponent,

    BookRowCatalogoDirective,

    TitoloFilterComponent,

    StagionalitaValidatorDirective,

    ContributorFilterComponent,

    AnnoFilterComponent,

    BisacSearchComponent,

    BisacSelectorComponent,

    CoversUploaderComponent,

    ContributorAddComponent,

    ContributorFormComponent,

    ContributorSearchListComponent,

    CceSearchComponent,

    CceSelectorComponent,

    UppercaseDirective,

    MatIconDehonianeComponent,

    RecensioneFormComponent,

    TestataComboSelectorComponent,

    CopertinarioComponent,

    ExtraFormComponent,

    TestataSearchComponent,

    TestataFormComponent,

    ArticoloSearchComponent,

    ArticoloFormComponent,

    NumeroFilterComponent,

    TipoArticoloSelectorComponent,

    AlfrescoArticoloSelectorComponent,

    CatalogazioneArticoloSelectorComponent,

    IndiceGeoSelectorComponent,

    MatIconMariettiComponent,

    TestataAutocompleteComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,

    // BrowserModule,
    // FormsModule,
    // ReactiveFormsModule,
    // BrowserAnimationsModule,
    HttpModule,
    RoutingModule,
    HttpClientModule,

    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,

    MalihuScrollbarModule.forRoot(),

    DragulaModule,

    ClipboardModule,

    Angular2SocialLoginModule,

    ToastyModule.forRoot(),

    StickyModule,

    TinymceModule.withConfig({
      skin_url: 'assets/tinymce/skins/light',
      auto_focus: false
    }),

    CurrencyMaskModule,

    FileUploadModule,

    SharedModule.forRoot()
  ],
  providers: [
    AuthHttp,
    {
      provide: AuthHttp,
      useFactory: getAuthHttp,
      deps: [Http]
    },
    BaseRequestOptions,

    {provide: LocationStrategy, useClass: HashLocationStrategy},

    { provide: LOCALE_ID, useValue: "it-IT" },
    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlIt },
    { provide: MAT_PLACEHOLDER_GLOBAL_OPTIONS, useValue: {float: 'always'} },

    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy
    }
  ],
  entryComponents: [
    AppSnackbarComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}

// Angular2SocialLoginModule.loadProvidersScripts({
//    "google": {
//      "clientId": "396869899152-08e99ct6tnh9dhku1pf7g2b3cneumueh.apps.googleusercontent.com"
//    },
//    "facebook": {
//      "clientId": "345141585896206",
//      "apiVersion": "v2.4"
//    }
//
//  })



// WEBPACK FOOTER //
// ./src/app/app.module.ts